export const validateIdNumber = (identityNumber: string): boolean => {
  const idWithoutSpaces = identityNumber.replace(/\s/g, '')
  const regex =
    /^(?!(?:0{13}|1{13}|2{13}|3{13}|4{13}|5{13}|6{13}|7{13}|8{13}|9{13}))\d{13}$/
  const isValid = regex.test(idWithoutSpaces)
  return isValid
}

export const validateContactNumber = (contactNumber: string): boolean => {
  const regex = /^(?:\+27|27|0)[1-9][0-9]{8}$/
  const isValid = regex.test(contactNumber)
  return isValid
}

export const validatePassportNumber = (passportNumber: string): boolean => {
  const regex = /^[A-Za-z0-9]{3,20}$/
  const isValid = regex.test(passportNumber)
  return isValid
}

export const validateCompanyRegistrationNumber = (
  registrationNumber: string,
) => {
  const regex = /^\s*[a-zA-Z\d]{4,5}\s*\/\s*\d{6}\s*\/\s*\d{2}$/
  const isValid = regex.test(registrationNumber)
  return isValid
}

export const validateKimNumber = (kimNumber: string) => {
  const regex = /[A-Za-z]+\d+/
  const isValid = regex.test(kimNumber)
  return isValid
}

export const validateVATNumber = (vatNumber: string) => {
  const regex = /^4\d{9}$/
  const isValid = regex.test(vatNumber)
  return isValid
}
